import React from 'react'
import PropTypes from 'prop-types'
import DataProviderService from '../services/data-provider'

class DataProvider extends React.Component {
  static propTypes = {
    dateRange: PropTypes.object,
    onRequest: PropTypes.func,
    onSuccess: PropTypes.func,
    onError: PropTypes.func
  }

  static defaultProps = {
    dateRange: null,
    onRequest: () => {},
    onSuccess: () => {},
    onError: () => {},
    fetchData: DataProviderService.get,
    getCached: DataProviderService.cached
  }

  componentDidMount() {
    if (this.props.dateRange) {
      this.syncState()
    }
  }

  componentDidUpdate(prevProps) {
    if (!this.props.dateRange) {
      return
    }

    if (!this.props.dateRange.equals(prevProps.dateRange)) {
      this.syncState()
    }
  }

  syncState() {
    let { getCached, dateRange } = this.props
    let data = getCached(dateRange)

    if (data) {
      this.props.onSuccess(data)
    } else {
      this.fetch(dateRange)
    }
  }

  fetch(dateRange) {
    this.props.onRequest()

    this.props
      .fetchData(dateRange)
      .then(data => {
        if (dateRange.equals(this.props.dateRange)) {
          this.props.onSuccess(data)
        }
      })
      .catch(this.props.onError)
  }

  render() {
    return null
  }
}

export default DataProvider
